import styled from 'styled-components';

import { ANIM, COLORS } from '../../theme/tokens';

export const Track = styled.div`
  height: 8px;
  border-radius: 99px;
  background: ${COLORS.progressTrack};
  overflow: hidden;
`;

export const Fill = styled.div<{ $color: string; $width: number; $delay: number }>`
  height: 100%;
  width: ${(p) => Math.min(100, Math.max(0, p.$width))}%;
  background: ${(p) => p.$color};
  border-radius: 99px;
  /* Grows from 0 to its target width on mount, staggered by $delay so the bars
     fill one after another (but overlapping, since the stagger << duration). */
  transition: width ${ANIM.BAR_DURATION_MS}ms cubic-bezier(0.22, 1, 0.36, 1);
  transition-delay: ${(p) => p.$delay}ms;
`;